module.exports = "/_next/static/images/lock-duotone-e525070c02472a70e2bdf6bf6a20a9c9.svg";